import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Button, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import SkeletonLoading from "../../../../components/SkeletonLoading";
import '../../../../styles/AppCss.css'
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Padding, PaletaColor } from "../../../../styles/StylesConstantes";
import { Add, Delete, Edit } from "@mui/icons-material";
import { getUsuarios } from "../../../../api/ApiService";
import { useNavigate } from "react-router-dom";
import { CssTextField } from "../../../../styles/styles";



function UsuariosLocalesPage() {
    const [loading, setLoading] = useState(false);
    const [dataPromociones, setDataPromociones] = useState([]);
    const [estadoPromociones, setEstadoPromociones] = useState('');
    const [searchName, setSearchName] = useState('');
    const [email, setEmail] = useState('');

    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));

    const stateToken = useSelector(state => state.reducerGlobal.token);

    let history = useNavigate();


    useEffect(() => {
        handleListarUsuarios();
    }, []);

    const handleListarUsuarios = () => {

        getUsuarios(stateToken?.body?.token, 1, 10)
            .then((response) => {
                console.log("response-getUsuarios", response);
                if (response.data.length > 0) {
                    setDataPromociones(response.data);
                    setLoading(true);
                } else {
                    setDataPromociones([]);
                    setLoading(true);
                }
            })
            .catch((error) => {
                console.log("error-getUsuarios", error);
                setDataPromociones([]);
                setLoading(true);
            });
    };


    const columns = [
        { field: 'id', headerName: 'ID', width: 90 },
        {
            field: 'name',
            headerName: 'Nombre',
            width: 150,
            editable: false,
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 250,
            editable: false,
        },
        {
            field: 'descripcion',
            headerName: 'Locales',
            type: 'number',
            width: 110,
            editable: false,
        },
        {
            field: 'status',
            headerName: 'Activo',
            width: 100,
            editable: false,
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                return [
                    <GridActionsCellItem
                        icon={<Edit />}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<Delete />}
                        label="Delete"
                        onClick={handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            },
        },
    ];



    //=================================================================================================funcion para editar, obtener el id
    const handleEditClick = (id) => () => {
        console.log('Edit', id);
        // history(`/app/admin/banners-detalle/${id}`, { state: null });
    };

    //=================================================================================================funcion para eliminar, obtener el id
    const handleDeleteClick = (id) => () => {
        console.log('Delete', id);
        setDataPromociones(dataPromociones.filter((row) => row.id !== id));
    }

    //=================================================================================================funcion para ir a la pantalla de agregar
    const handleAddPromocion = () => {
        history('/app/admin/paseo-plus-user-locales-agregar', { state: null });
    };



    //=============================================funcion para buscar por nombre
    const handleSearch = (e) => {
        setSearchName(e);
    }

    //=============================================funcion para buscar por email
    const handleSearchEmail = (e) => {
        setEmail(e);
    }

    return (
        <HeaderCustom>
            <div style={{
                marginTop: Padding.P2,
                padding: Padding.P2,
            }}>
                {loading ? (
                    <div style={{
                        backgroundColor: PaletaColor.BLANCO,
                        borderRadius: Padding.P1,
                        padding: Padding.P3,
                    }}>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignContent: 'center', marginBottom: Padding.P2 }}>
                            <Typography variant={'h5'} style={{}}>
                                Usuarios para locales
                            </Typography>


                            <div style={{}}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    style={{
                                        backgroundColor: PaletaColor.AZUL_OSCURO,
                                        color: PaletaColor.BLANCO,
                                        fontWeight: 'bold',
                                        // height: 50
                                    }}
                                    startIcon={<Add />}
                                    onClick={handleAddPromocion}
                                >
                                    Crear Usuario para local
                                </Button>
                            </div>
                        </div>


                        <div style={{ marginTop: Padding.P1, marginBottom: Padding.P3 }} >
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                <div style={{}}>
                                    <div>
                                        <Typography variant={'subtitle1'} style={{}}>
                                            Buscar
                                        </Typography>
                                    </div>

                                    <CssTextField
                                        value={searchName}
                                        onChange={(e) => handleSearch(e.target.value)}
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        label="Buscar por nombre"
                                        autoCapitalize='none'
                                        autoCorrect={false}
                                        style={{
                                            marginTop: Padding.P1,
                                            width: 500,
                                        }}
                                    />
                                </div>

                                <div style={{ marginLeft: Padding.P4 }}>
                                    <div>
                                        <Typography variant={'subtitle1'} style={{}}>
                                            Buscar por email
                                        </Typography>
                                    </div>

                                    <CssTextField
                                        value={email}
                                        onChange={(e) => handleSearchEmail(e.target.value)}
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        label="Buscar por email"
                                        autoCapitalize='none'
                                        autoCorrect={false}
                                        style={{
                                            marginTop: Padding.P1,
                                            width: 500,
                                        }}
                                    />
                                </div>

                            </div>

                        </div>

                        <DataGrid
                            rows={dataPromociones}
                            columns={columns}
                            rowHeight={100}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 5,
                                    },
                                },
                            }}
                            pageSizeOptions={[5]}
                            checkboxSelection
                            disableRowSelectionOnClick
                        />
                    </div>
                ) : (
                    <Container sx={{}} style={{}}>
                        <SkeletonLoading />
                    </Container>
                )}
            </div>
        </HeaderCustom>
    );
}

export default UsuariosLocalesPage;